import { captureException } from "@sentry/react";

export const ensureError = (err: unknown): Error => {
  if (err instanceof Error) return err;
  if (typeof err === "string") return new Error(err);
  if (hasMessage(err)) return new Error(err.message);

  return new Error("Ukendt fejl");
};

type MessageHolder = { message: string };
const hasMessage = (x: unknown): x is MessageHolder => {
  return (
    typeof x === "object" &&
    x !== null &&
    "message" in x &&
    typeof x.message === "string"
  );
};

export const trackSilentErrorSentry = (message: string) => {
  console.error(message);
  captureException(new Error(message));
};
